import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { OPEN_COOKIE_SETTINGS_EVENT, getConsentPrefs, setConsentPrefs } from '../../utils/ads';

function Toggle({ checked, onChange, disabled = false }: { checked: boolean; onChange?: (v: boolean) => void; disabled?: boolean }) {
    return (
        <input
            type="checkbox"
            className="w-5 h-5 mt-0.5 shrink-0 accent-[#19315f]"
            checked={checked}
            disabled={disabled}
            onChange={(e) => onChange?.(e.target.checked)}
        />
    );
}

function CookieConsent() {
    const [visible, setVisible] = useState(false);
    const [showDetails, setShowDetails] = useState(false);
    const [analytics, setAnalytics] = useState(false);
    const [ads, setAds] = useState(false);

    const open = (details: boolean) => {
        const prefs = getConsentPrefs();
        setAnalytics(prefs?.analytics ?? false);
        setAds(prefs?.ads ?? false);
        setShowDetails(details);
        setVisible(true);
    };

    useEffect(() => {
        if (getConsentPrefs() === null) open(false);
        const onOpen = () => open(true);
        window.addEventListener(OPEN_COOKIE_SETTINGS_EVENT, onOpen);
        return () => window.removeEventListener(OPEN_COOKIE_SETTINGS_EVENT, onOpen);
    }, []);

    if (!visible) return null;

    const save = (prefs: { analytics: boolean; ads: boolean }) => {
        setConsentPrefs(prefs);
        setVisible(false);
    };

    return (
        <div className="fixed bottom-0 left-0 right-0 z-[9999] bg-white border-t border-[#ccc] shadow-lg px-4 py-3 max-h-[90vh] overflow-y-auto">
            <div className="max-w-[1100px] mx-auto flex flex-col gap-3">
                <p className="text-[14px] leading-5 text-black">
                    Koristimo kolačiće da sajt radi, da bismo razumeli kako se koristi i da prikažemo oglase koji nam pomažu da sajt ostane besplatan. Možete
                    izabrati koje kategorije dozvoljavate. Više informacija je u{' '}
                    <Link to="/user/privacy" className="underline text-blue-700">
                        Politici privatnosti
                    </Link>
                    .
                </p>

                {showDetails && (
                    <div className="flex flex-col gap-3 text-black text-[14px] leading-5">
                        <label className="flex gap-3 items-start">
                            <Toggle checked disabled />
                            <span>
                                <b>Neophodni</b> – prijava, čuvanje napretka i pamćenje vašeg izbora. Sajt ne radi bez njih, pa su uvek uključeni.
                            </span>
                        </label>
                        <label className="flex gap-3 items-start cursor-pointer">
                            <Toggle checked={analytics} onChange={setAnalytics} />
                            <span>
                                <b>Analitika</b> – Google Analytics, anonimna statistika posećenosti koja nam pomaže da poboljšamo sajt.
                            </span>
                        </label>
                        <label className="flex gap-3 items-start cursor-pointer">
                            <Toggle checked={ads} onChange={setAds} />
                            <span>
                                <b>Oglasi (marketing)</b> – Google AdSense prikazuje oglase i može da koristi kolačiće za njihovu relevantnost i merenje.
                            </span>
                        </label>
                    </div>
                )}

                <div className="flex flex-col sm:flex-row gap-2 sm:justify-end">
                    <button
                        onClick={() => save({ analytics: false, ads: false })}
                        className="px-4 h-[36px] border border-black rounded-[4px] text-[14px] font-semibold bg-white text-black"
                    >
                        Samo neophodni
                    </button>
                    {showDetails ? (
                        <button
                            onClick={() => save({ analytics, ads })}
                            className="px-4 h-[36px] border border-black rounded-[4px] text-[14px] font-semibold bg-white text-black"
                        >
                            Sačuvaj izbor
                        </button>
                    ) : (
                        <button
                            onClick={() => setShowDetails(true)}
                            className="px-4 h-[36px] border border-black rounded-[4px] text-[14px] font-semibold bg-white text-black"
                        >
                            Prilagodi
                        </button>
                    )}
                    <button
                        onClick={() => save({ analytics: true, ads: true })}
                        className="px-4 h-[36px] rounded-[4px] text-[14px] font-semibold bg-blueDark text-white"
                    >
                        Prihvatam sve
                    </button>
                </div>
            </div>
        </div>
    );
}

export default CookieConsent;
